import axios from '../utils/request'

// 获取用户账号信息
const GetUserInfo = () => {
  return axios.get('GetAccountInfo')
}

const GetRoleInfo = () => {
  return axios.get('GetRoleInfo')
}

const JurisdictionUserinfo = () => {
  return axios.get('GetJurisdictionUserinfo')
}

const JurisdictionData = (userid) => {
  return axios.get('GetJurisdictionData?userid=' + userid)
}

const ChangeJurisdiction = (userid, MenuID, isCheck) => {
  return axios.get('ChangeJurisdiction?userid=' + userid + '&Menu_ID=' + MenuID + '&isCheck=' + isCheck)
}

// 变更用户账号信息
const ChangeAccountInfo = (loginInfo) => {
  return axios.post('ChangeAccountInfo', {
    ...loginInfo
  })
}

export {
  GetUserInfo,
  GetRoleInfo,
  ChangeAccountInfo,
  JurisdictionUserinfo,
  JurisdictionData,
  ChangeJurisdiction
}
